import { defineComponent as _defineComponent } from 'vue';
import { ComboboxAnchor } from 'reka-ui';
import { cva } from 'class-variance-authority';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ComboboxAnchor',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        disabled: { type: Boolean, required: false },
        readonly: { type: Boolean, required: false },
        hasError: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const anchorVariants = cva('h-9 w-full flex items-center rounded-md border border-input bg-transparent px-3 shadow-xs transition-colors', {
            variants: {
                disabled: { true: 'cursor-not-allowed opacity-50', false: '' },
                readonly: { true: 'cursor-not-allowed', false: '' },
                hasError: { true: 'border-destructive ring-[0.5px] ring-destructive', false: '' },
            },
            compoundVariants: [
                { hasError: false, class: 'focus-within:ring-2 focus-within:ring-ring focus-within:ring-inset' },
            ],
        });
        const __returned__ = { props, anchorVariants, get ComboboxAnchor() { return ComboboxAnchor; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
